// src/pages/payment-success.jsx
import { Link } from 'react-router-dom';

export default function PaymentSuccess() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-green-50 px-6">
      <div className="bg-white shadow-lg rounded-xl p-10 max-w-md text-center">
        <h1 className="text-3xl font-bold text-green-600 mb-4">Payment Successful 🎉</h1>
        <p className="text-gray-700 mb-6">
          Thank you for your purchase. Your access will be activated shortly.
        </p>
        <Link
          to="/lessons"
          className="inline-block px-6 py-3 bg-green-600 text-white font-semibold rounded-md hover:bg-green-700 transition"
        >
          Go to Lessons
        </Link>
      </div>
    </main>
  );
}
